const RESOLUTION_LIST = {
    HD: "HD",
    FHD: "FHD",
    "4K": "4K"
};

export { RESOLUTION_LIST };